import type { CrudServiceListResponse } from '@empathyco/playboard-core-domain'
import type { ActionContext } from 'vuex'
import type { ActionClass, ToolingState } from '../../../models'
import type { CrudServiceProvider } from '../../../providers/interfaces'
import { CONTAINER } from '../../../config/inversify.config'
import { TYPES } from '../../../config/inversify.types'
import { TOOLING_CONSTS } from '../tooling.consts'

export class ListAction implements ActionClass {
  static async execute(
    this: void,
    { commit }: ActionContext<ToolingState, unknown>,
    { tool, params }: { tool: string; params?: unknown },
  ): Promise<CrudServiceListResponse> {
    const service = CONTAINER.get<CrudServiceProvider>(TYPES.CrudServiceProvider)(tool)
    const data = await service.list(params)
    commit(TOOLING_CONSTS.mutations.setState, { [tool]: { data } })
    return data
  }
}
